import classnames from 'classnames';
import { FunctionComponent } from 'react';
import Picture from '@media-ui/core/src/components/Picture';
import Text from '@media-ui/core/src/components/Text';
import * as styles from './ConsultationListItem.css';
import * as T from './ConsultationListItem.types';
export const ConsultationListItem: FunctionComponent<T.ConsultationListItemProps> = ({ className, classNameHeader, classNameContent, url, title, authorUrl, authorImg, authorName, authorSpec, authorClb, bodyClb, children, isTouch, }) => {
    const clbAttr = {
        author: { name: authorClb ? `clb${authorClb}` : undefined },
        body: { name: bodyClb ? `clb${bodyClb}` : undefined },
    };
    const avatarSize = isTouch ? '48px' : '96px';
    return (<div data-qa="ConsultantionItem" className={classnames(styles.root, className)}>
      <div className={classnames(styles.header, classNameHeader)}>
        <div data-qa="ConsultantAvatar" className={styles.avatar}>
          {authorImg ? (<Picture className={styles.picture} objectFit="cover" width={avatarSize} height={avatarSize} {...authorImg} lazy/>) : null}
        </div>
        <div className={styles.desc}>
          <a {...clbAttr.author} className={styles.linkStyle} href={authorUrl} data-qa="ConsultantName">
            {authorName}
          </a>
          <Text type="footnote" data-qa="ConsultantSpec" className={styles.descInfo}>
            {authorSpec}
          </Text>
        </div>
      </div>
      <div data-qa="ConsultantionItemContent" className={classnames(styles.content, classNameContent)}>
        <a {...clbAttr.body} className={`${styles.linkStyle} ${styles.titleLink}`} href={url} data-qa="ConsultantionItemTitle">
          {title}
        </a>
        <div data-qa="ConsultantionItemText">{children}</div>
      </div>
    </div>);
};
